<template>
  <div v-loading="webviewLoading">
    <h1 v-if="errorMessage">{{ errorMessage }}</h1>
    <div v-else class="mobile-page">
      <h2>YOUR EXTENSION</h2>
      <h2 class="ext-number">{{ extNumber }}</h2>

      <h2>YOUR QUEUES</h2>
      <div class="queue-controls flex align-center">
        <dads-select v-model="selectedQueueId">
          <el-option
            v-for="{ queue_name, qu_name } in queueList"
            :key="queue_name"
            :label="qu_name"
            :value="queue_name"
          />
        </dads-select>
      </div>
      <div class="flex justify-center align-center mt-10">
        <label for="loginSwitch" class="mr-20">
          <div v-loading="loginProcessing">
            <p class="mb-0 mt-0 switch-text">
              {{ loginStatus ? "Logged In" : "Logged Out" }}
            </p>
            <el-switch :value="loginStatus" />
          </div>

          <input
            id="loginSwitch"
            type="checkbox"
            v-model="loginChecked"
            @change="onLoginStatusChanged"
            style="display: none"
          />
        </label>

        <label for="pauseSwitch">
          <div v-loading="pauseProcessing && !pauseModalVisible">
            <p class="mb-0 mt-0 switch-text">
              {{ pauseStatus ? "Paused" : "Unpaused" }}
            </p>
            <el-switch :value="pauseStatus" />
          </div>

          <input
            id="pauseSwitch"
            type="checkbox"
            v-model="checkedPause"
            @change="onPauseStatusChanged"
            style="display: none"
          />
        </label>
      </div>

      <div class="controls">
        <button @click="faxModalVisible = true">
          <img src="@/assets/images/send_fax_bg.jpg" alt="Send fax" />
          <div class="control-info fax pl-10 pb-10">
            <h3 class="text-left">Send a fax</h3>
            <p class="text-left">Tap here</p>
          </div>
        </button>

        <button @click="voicemailModalVisible = true">
          <img src="@/assets/images/check_vm_bg.jpg" alt="Check voicemail" />
          <div class="control-info voicemail pr-10 pb-10">
            <h3 class="text-right">Voicemail</h3>
            <p class="text-right">{{ totalVoicemails }} new</p>
          </div>
        </button>
      </div>

      <queue-pause
        ref="pauseModal"
        :visible="pauseModalVisible"
        :pauseProcessing="pauseProcessing"
        @pauseOperation="pauseOperation"
        @closeOperation="closeQueuePause"
      />

      <fax-form
        ref="faxForm"
        :visible="faxModalVisible"
        :userParams="userParams"
        :faxProcessing="faxProcessing"
        @closeOperation="faxModalVisible = false"
        @faxOperation="faxOperation"
      />

      <voicemail-list
        :voicemails="voicemails"
        :userParams="userParams"
				:authKey="authKey"
        :visible="voicemailModalVisible"
        @voicemailDeleted="onVoicemailDeleted"
        @voicemailRead="onVoicemailRead"
        @closeOperation="voicemailModalVisible = false"
      />
    </div>
  </div>
</template>

<script>
import DadsSelect from "@/components/select";
import QueuePause from "./components/queuePause.vue";
import faxForm from "./components/faxForm.vue";
import VoicemailList from "./components/voicemailList.vue";
import { hostServer } from "../../feathers/feathers-client";

export default {
  name: "VoxoMobile",

  components: { DadsSelect, QueuePause, faxForm, VoicemailList },

  data() {
    return {
      // ⭐️ Web View ⭐️ //
      authKey: "",
      username: "",
      password: "",
      userParams: null,
      voicemails: null,
      extNumber: "",
      webviewLoading: false,
      totalVoicemails: 0,

      // ⭐️ Login / Log out Queue ⭐️ //
      selectedQueueId: "",
      selectedQueue: {},
      queueList: [],
      loginProcessing: false,
      loginStatus: false,
      loginChecked: false,

      // ⭐️ Pause / UnPause Queue ⭐️ //
      pauseModalVisible: false,
      pauseProcessing: false,
      pauseStatus: false,
      checkedPause: false,

      // ⭐️ Fax ⭐️ //
      faxModalVisible: false,
      faxProcessing: false,

      // ⭐️ Voicemail ⭐️ //
      voicemailModalVisible: false,

      // ⭐️ Error ⭐️ //
      errorMessage: null,
    };
  },
  watch: {
    selectedQueueId(val) {
      if (val) {
        this.selectedQueue = this.userParams.queues.find(
          (queue) => queue.queue_name === this.selectedQueueId
        );
        this.loginStatus = this.selectedQueue.logged_in === 1;
        this.loginChecked = this.loginStatus;
      }
    },
  },
  methods: {
    queryWebview() {
      this.webviewLoading = true;
      fetch(
        `${hostServer}/voxo-mobile/web-view_${this.authKey}?username=${this.username}&password=${this.password}`
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {

          this.webviewLoading = false;
          if (`${res.code}`.startsWith("4")) {
            this.errorMessage = res.message;
            return;
          }

          this.extNumber = res.userParams.ext;
          this.errorMessage = null;
          this.userParams = res.userParams;
          this.voicemails = res.vm_messages;
          this.queueList = res.userParams.queues;
          this.selectedQueueId = this.queueList[0].queue_name;

          const unreadMails = this.voicemails.filter(
            (mail) => mail.status === "unread"
          );
          this.totalVoicemails = unreadMails.length;
        })
        .catch((e) => {
          console.log(e);
          this.webviewLoading = false;
        });
    },

    onLoginStatusChanged(el) {
      this.toggleLoginStatus(el.target.checked);
    },

    toggleLoginStatus(status) {
      const { queue_name, membername } = this.selectedQueue;
      const { username, extId, hostServer, noAuthKey } = this.userParams;

      const reqParams = {
        reqType: status ? "queueLogin" : "queueLogout",
        peerName: username,
        queueId: queue_name,
        memberName: membername,
        extensionId: extId,
        server: hostServer,
      };

      this.loginProcessing = true;
      fetch(`https://api.voxo.co/nats-actions-handler?noAuth=${noAuthKey}`, {
        method: "POST",
        body: JSON.stringify(reqParams),
        headers: {
          "content-type": "application/json",
        },
      })
        .then((res) => {
          if (`${res.status}`.startsWith("2")) {
            this.loginStatus = status;
            this.loginChecked = status;
          }
          this.loginProcessing = false;
        })
        .catch(() => {
          this.loginProcessing = false;
        });
    },

    onPauseStatusChanged(el) {
      if (el.target.checked) {
        this.pauseModalVisible = true;
        return;
      }

      this.pauseOperation();
    },

    pauseOperation(pauseReason) {
      const {
        queue_name,
        membername,
        interface: Interface,
      } = this.selectedQueue;
      const { username, extId, hostServer, noAuthKey } = this.userParams;

      const reqParams = {
        reqType: this.checkedPause ? "queuePause" : "queueUnpause",
        peerName: username,
        queueId: queue_name,
        memberName: membername,
        interface: Interface,
        extensionId: extId,
        server: hostServer,
        paused: this.checkedPause ? 1 : 0,
      };

      if (this.checkedPause) {
        reqParams.pauseReason = pauseReason;
      }

      this.pauseProcessing = true;
      fetch(`https://api.voxo.co/nats-actions-handler?noAuth=${noAuthKey}`, {
        method: "POST",
        body: JSON.stringify(reqParams),
        headers: {
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(() => {
          this.pauseProcessing = false;
          this.pauseModalVisible = false;
          this.pauseStatus = this.checkedPause;
        })
        .catch(() => {
          this.pauseProcessing = false;
        });

      this.$refs.pauseModal.clearFields();
    },

    closeQueuePause() {
      this.pauseModalVisible = false;
      this.checkedPause = false;
      this.pauseStatus = false;
    },

    faxOperation(formData) {
      this.faxProcessing = true;
      fetch(`${hostServer}/voxo-mobile?reqType=send-fax&authKey=${this.authKey}`, {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((res) => {
          this.faxProcessing = false;
          if (`${res.code}`.includes("4")) {
            return this.$notify({
              title: "Invalid Request",
              type: "error",
              message: res.message,
            });
          }

          this.$notify({
            title: "Success",
            message: "Successfully sent the fax.",
            type: "success",
          });
          this.faxModalVisible = false;

          this.$refs.faxForm.clearFields();
        })
        .catch(() => {
          this.faxProcessing = false;
        });
    },

    onVoicemailDeleted(id) {
      const idx = this.voicemails.findIndex((vm) => vm.id === id);
      if (idx !== -1) {
        this.voicemails.splice(idx, 1);
      }
      this.updateNewMessages();
    },

    onVoicemailRead(id) {
      const idx = this.voicemails.findIndex((vm) => vm.id === id);
      if (idx !== -1) {
        this.voicemails[idx].status = "read";
      }
      this.updateNewMessages();
    },

    updateNewMessages() {
      const unread = this.voicemails.filter(item => item.status === "unread");
      this.totalVoicemails = unread.length;
    }
  },

  created() {
    const {
      params: { authKey },
      query: { username, password },
    } = this.$route;
    this.authKey = authKey;
    this.username = username;
    this.password = password;
  },

  mounted() {

    //force light mode
    document.body.setAttribute('class', 'theme-default');

    this.queryWebview();
  },
};
</script>

<style scoped lang="scss">
h1 {
  text-align: center;
  margin-top: 100px;
}

.mobile-page {
  padding-top: 40px;
  max-width: 900px;
  margin: 0 auto;

  h2 {
    text-align: center;
    margin: 0;
    margin-bottom: 5px;
    font-weight: normal;

    &.ext-number {
      color: blue;
      margin-bottom: 20px;
    }
  }

  .queue-controls {
    display: flex;
    justify-content: center;
    align-items: center;

    & > *:not(:last-child) {
      margin-right: 25px;
    }
  }

  .switch-text {
    font-size: 12px;
  }

  .controls {
    margin-top: 50px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;

    button {
      display: block;
      background: transparent;
      border: none;
      cursor: pointer;
      position: relative;
      padding: 0;

      img {
        display: block;
        width: 100%;
        border-radius: 10px;
      }

      .control-info {
        position: absolute;
        color: #fff;
        bottom: 0;

        &.fax {
          left: 0;
        }

        &.voicemail {
          right: 0;
        }

        h3 {
          margin: 0;
          font-size: 20px;
        }

        p {
          margin: 0;
        }
      }

      &:first-child::before,
      &:last-child::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        border-radius: 10px;
      }

      &:first-child::before {
        background: linear-gradient(
          rgba(82, 96, 126, 0.85),
          rgba(82, 96, 126, 0.85)
        );
      }

      &:last-child::before {
        background: linear-gradient(
          rgba(102, 119, 226, 0.85),
          rgba(102, 119, 226, 0.85)
        );
      }
    }
  }
}
</style>
